import { getSangjoQuotations } from "@/apis/sangjoQuotation";
import { isLoggedInState } from "@/atoms/accountState";
import CallFixedButton from "@/components/common/CallFixedButton";
import LoadingProvider from "@/components/Provider/LoadingProvider";
import { Box } from "@chakra-ui/react";
import {
  Button,
  colors,
  GLOBAL_MAX_WIDTH,
  HStack,
  queryKeys,
  TopBanner,
  useResponsive,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import GuideSlider from "./components/MatchRecommendations/GuideSlider";
import HeadBanner from "./components/MatchRecommendations/HeadBanner";
import RecommendationCardListCarousel from "./components/MatchRecommendations/RecommendationCardListCarousel";

function MatchRecommendationsContainer() {
  const { isBiggerThanLg } = useResponsive();
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const { data, isLoading } = useQuery(queryKeys.sangjoQuotation, () => getSangjoQuotations(), {
    enabled: isLoggedIn,
  });
  const router = useRouter();
  const isCTAButtonVisible = useMemo(() => {
    if (!isLoggedIn) return true;
    if (data && data.quotations.length > 0) {
      return false;
    } else {
      return true;
    }
  }, [isLoggedIn, data]);
  return (
    <LoadingProvider isLoading={isLoading}>
      <VStack width="100%" alignItems="center">
        <CallFixedButton />
        <VStack width="100%" maxWidth={GLOBAL_MAX_WIDTH} alignItems="center">
          <TopBanner path="mtch_recomm_lst" />

          <VStack width="100%" maxWidth={GLOBAL_MAX_WIDTH}>
            <HeadBanner />
          </VStack>

          <HStack
            width="100%"
            justifyContent="space-between"
            maxWidth={isBiggerThanLg ? "800px" : "480px"}
          >
            <Box width="100%" pb="120px">
              <VStack gap="8px" padding="16px 0 8px" width="100%">
                {isCTAButtonVisible ? (
                  <>
                    <Box padding="6px 24px" className="caption_12_m gray600" textAlign="center">
                      장례식장, 장지 비용까지 한번에 알아보세요
                    </Box>
                    <Box padding="0 24px" width="100%" overflow="hidden">
                      <Button
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          backgroundColor: colors.orange650,
                        }}
                        event={{
                          newGtm: {
                            path: "mtch_recomm_lst",
                            trigger_and_target: "CTA-uv_match_request",
                          },
                        }}
                        onClick={() => {
                          router.push("/match/request");
                        }}
                        className="button_14_sb white"
                      >
                        장례 서비스 한번에 추천받기
                      </Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box padding="0 24px" className="body_14_m gray600">
                      어떤 서비스를 선택해야 할까요?
                    </Box>
                    <Box width="100%" overflow="hidden">
                      <GuideSlider />
                    </Box>
                  </>
                )}
              </VStack>
              <RecommendationCardListCarousel />
            </Box>
          </HStack>
        </VStack>
      </VStack>
    </LoadingProvider>
  );
}

export default MatchRecommendationsContainer;
